import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { FaDownload, FaTrash } from "react-icons/fa";
import dummyImg from "../../../../../src/assets/images/product/1.png";
import { useParams } from "react-router";
import axios from "axios";
import { baseURL, getPublicS3Url, imageURL, orderURL } from "../../../../Services/api/baseURL";
import moment from "moment";
import star from "../../../../../src/assets/images/Star.svg";
import { BackgroundColor } from "../../../../Constant";
import Swal from "sweetalert2";
const ProductDetails = () => {
  const { id } = useParams();
  const [product, setOrderDetails] = useState();
      const token = JSON.parse(localStorage.getItem("token"));
    console.log(token)
  const getOrderDetails = async () => {
    try {
      await axios
        .get(`${baseURL}/api/product/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log(res);
          if (res && res.status === 200) {
            //console.log(res.data, "data by id for service");
            // let response = res?.data?.data.length > 0 && res.data?.data[0];
            setOrderDetails(res?.data?.product);
          }
        });
    } catch (err) {
      console.error(err);
    }
  };
      const handleDeleteProduct = async () => {
          // Show confirmation dialog
          const result = await Swal.fire({
              title: 'Are you sure?',
              text: 'You will not be able to recover this product!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!',
              cancelButtonText: 'Cancel'
          });

          // If user confirmed, proceed with deletion
          if (result.isConfirmed) {
              try {
                  await axios.delete(`${baseURL}/api/product/${id}`, {
                      headers: { Authorization: `Bearer ${token}` }
                  });
      
                  Swal.fire({
                      icon: 'success',
                      title: 'Product Deleted',
                      showConfirmButton: false,
                      timer: 1500
                  });
                  // Redirect or update UI after deletion
                  window.history.back();
              } catch (error) {
                  Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: error.response?.data?.message || 'Failed to delete product'
                  });
              }
          }
      };
  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }
  const statusColors = {
    accepted: "primary",
    processing: "info",
    "on-the-way": "warning",
    delivered: "success",
    rejected: "danger",
  };
  useEffect(() => {
    if (id) {
      getOrderDetails();
    }
  }, []);
//   const color = statusColors[statusKey] || "primary";
  console.log(product);
  return (
    <>
      <Container fluid>
        <div className="page-title">
          <Row className="align-items-center">
            <Col xs="6">
              <p className="mb-0 d-flex align-items-center">
                Product Id: <b className="ms-1"> {product?._id}</b>{" "}
                <span style={{ color: "#E1E6EF" }} className="mx-2">
                  {" "}
                  |{" "}
                </span>{" "}
                <span
                  style={{ fontSize: "13px",color: "#000000" }}
                >
                    <b>{product?.isBestSeller === true
                    ? "Best Seller"
                    : ""}</b>
                  
                </span>
              </p>
            </Col>
            <Col xs="6">
              <div className="d-flex justify-content-end">
                {/* <Button className='filter_btn'
                                onClick={() => downloadInvoice(id)}
                            >
                                <FaDownload color='#d422ad' />
                            </Button> */}

                <Button className='filter_btn ms-2' onClick={handleDeleteProduct}>
                                <FaTrash color='red' />
                            </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <button style={{margin: "0px 0 10px 0"}} onClick={() => window.history.back()}> {" < "}Back to Products</button>

      <Container fluid>
      <Row className="gy-4">

        {/* ✅ Basic Info */}
        <Col lg={6}>
          <Card>
            <CardHeader>
              <h5>Basic Info</h5>
            </CardHeader>
            <CardBody>
              <Table className="detail_table">
                <tr>
                  <th>Product Name :</th>
                  <td>
                    {product?.name}{" "}
                    {product?.isBestSeller && (
                      <span className="badge bg-success ms-2">Best Seller</span>
                    )}
                  </td>
                </tr>
                 <tr>
                  <th>Category Name :</th>
                  <td>{product?.category?.name}</td>
                </tr>
                <tr>
                  <th>Description :</th>
                  <td>{product?.description || "N/A"}</td>
                </tr>
                <tr>
                  <th>Selling Type :</th>
                  <td>{product?.sellingType}</td>
                </tr>
              </Table>
            </CardBody>
          </Card>
        </Col>

       

        {/* ✅ Pricing & Stock */}
        <Col lg={6}>
          <Card>
            <CardHeader>
              <h5>Pricing & Stock</h5>
            </CardHeader>
            <CardBody>
              <Table className="detail_table">
                {product?.sellingType === "unit" && (
                  <>
                    <tr>
                      <th>Price :</th>
                      <td>₹{product?.unitDetails?.price || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Stock :</th>
                      <td>{product?.unitDetails?.stock}</td>
                    </tr>
                  </>
                )}

                {product?.sellingType === "weight" && (
                  <>
                    <tr>
                      <th>Price Per Kg :</th>
                      <td>
                        ₹{product?.weightDetails?.pricePerKg}{" "}
                        <small className="text-muted">
                          (Original: ₹{product?.weightDetails?.originalPricePerKg})
                        </small>
                      </td>
                    </tr>
                    <tr>
                      <th>Options :</th>
                      <td>
                        <ul style={{ paddingLeft: "15px" }}>
                          {product?.weightDetails?.options?.map((opt) => (
                            <li key={opt._id}>
                              {opt.weight} Kg — ₹{opt.price} (Stock: {opt.stock})
                            </li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  </>
                )}
              </Table>
            </CardBody>
          </Card>
        </Col>

        {/* ✅ Additional Details */}
        <Col lg={12}>
          <Card>
            <CardHeader>
              <h5>Additional Details</h5>
            </CardHeader>
            <CardBody>
              <Table className="detail_table">
                {product?.productDetails &&
                Object.keys(product.productDetails).length > 0 ? (
                  Object.entries(product.productDetails).map(([key, value]) => (
                    <tr key={key}>
                      <th>{key} :</th>
                      <td>{value}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </Table>
            </CardBody>
          </Card>
        </Col>

        {/* ✅ Images */}
        <Col lg={12}>
          <Card>
            <CardHeader>
              <h5>Product Images</h5>
            </CardHeader>
            <CardBody>
              <div className="d-flex flex-wrap">
                {product?.images?.map((image, idx) => (
                  <div key={idx} style={{ width: "20%", padding: "5px" }}>
                    <img
                      src={getPublicS3Url(image)}
                      alt={`Product ${idx + 1}`}
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </Col>

      </Row>
    </Container>

    </>
  );
};

export default ProductDetails;
